/// <reference path="../app.typings.d.ts" />
'use strict';
var ap;
(function (ap) {
    /**
     * Common utilities created to minify duplicate code for consistent checks and methods.
     * NOTE: These do NOT work in the HTML and should be passed from the controllers if you need the check in html.
     */
    var Utilities = /** @class */ (function () {
        function Utilities() {
        }
        /**
         * Creates a deep copy of the specified object. which should be an object or an Array but can also be a primitive type if needed.
         * NOTE: If the object is null or undefined then the original object is returned.
         * @param object - The object to be copied.
         */
        Utilities.copy = function (object) {
            if (Utilities.isNullOrUndefined(object)) {
                return object;
            }
            return JSON.parse(JSON.stringify(object));
        };
        /**
         * Returns an array of Key / Value pairs created from an enum
         * @param enumeration - The enum to create the array from
         * @returns { IKeyValuePair<number, string> }
         */
        Utilities.createKeyValueArray = function (enumeration) {
            var keyValueArray = [];
            Object.keys(enumeration)
                .filter(function (value) { return isNaN(parseInt(value, 10)); })
                .forEach(function (stringKey) {
                keyValueArray.push({
                    key: enumeration[stringKey],
                    value: stringKey.split(/(?=[A-Z])/).join(' ')
                });
            });
            return keyValueArray;
        };
        Utilities.extend = function (clearObjectPropertiesFirst, target, object1) {
            var objectN = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                objectN[_i - 3] = arguments[_i];
            }
            if (clearObjectPropertiesFirst) {
                for (var member in target) {
                    if (target.hasOwnProperty[member]) {
                        delete target[member];
                    }
                }
            }
            return $.extend(target, object1, objectN);
        };
        /**
         * Returns a value indicating whether the specified object is null or undefined, false otherwise;
         * @param object - The object to be validated
         * @returns { boolean }
         */
        Utilities.isNullOrUndefined = function (object) {
            return object === null || typeof (object) === 'undefined';
        };
        /**
         * Returns a value indicating whether the specified input is a string and is not null or only white space characters.
         * @param input - the string input to be validated
         * @returns { boolean }
         */
        Utilities.isNullOrWhitespace = function (input) {
            return this.isNullOrUndefined(input) || typeof input !== 'string' || input.replace(/\s/g, '') === '';
        };
        /**
         * Returns a value indicating whether the specified collection parameter is null/undefined, not an array or has no items in the collection.
         * @param collection - The collection to be validated
         * @returns { boolean }
         */
        Utilities.isNullOrEmptyCollection = function (collection) {
            return this.isNullOrUndefined(collection) || Object.prototype.toString.call(collection) !== '[object Array]' || collection.length === 0;
        };
        /**
         * Gets a value indicating whether the specified value is null/undefined or is equal to the true value
         * <string>"True", <string>"true", <boolean>true, <number>1, <string>"1" all return true, false otherwise.
         * @param value - The value to be processed
         * @returns { Boolean }
         */
        Utilities.isNullOrTrueValue = function (value) {
            return Utilities.isNullOrUndefined(value) || Utilities.isTrueValue(value);
        };
        /**
         * Gets a value indicating whether the specified value is NOT null/undefined and is equal to the true value
         * <string>"True", <string>"true", <boolean>true, <number>1, <string>"1" all return true, false otherwise.
         * @param value - The value to be processed
         * @returns { Boolean }
         */
        Utilities.isTrueValue = function (value) {
            var stringValue = (value || '').toString().toLowerCase().trim();
            return !Utilities.isNullOrWhitespace(stringValue) && (value === true
                || stringValue === 'true'
                || stringValue === '1');
        };
        /**
         * Sort the specified array by the specified property name.
         * @param array - The array to be sorted
         * @param propertyName - The property name to be sorted by.
         * @param ascending - A value indicating whether the values should be sorting in ascending order.
         * @returns { Array of type T }
         */
        Utilities.sortByProperty = function (array, propertyName, ascending) {
            Utilities.sortByProperties(array, [{ propertyName: propertyName, ascending: this.isNullOrTrueValue(ascending) }]);
        };
        /**
         * Sort the specified array by the specified property names, in the order they appear.
         * @param array - The array to be sorted
         * @param sortProperties - an array of ISortProperty.
         * @returns { Array of type T }
         */
        Utilities.sortByProperties = function (array, sortProperties) {
            if (Utilities.isNullOrEmptyCollection(array)) {
                return;
            }
            array.sort(function (a, b) {
                var asc;
                var comparePropertyA;
                var comparePropertyB;
                var i;
                var j;
                var propertyCount = sortProperties.length;
                var propertyNames = [];
                var propertyNamesCount;
                for (i = 0; i < propertyCount; i++) {
                    asc = sortProperties[i].ascending;
                    propertyNames = sortProperties[i].propertyName.split('.');
                    propertyNamesCount = propertyNames.length;
                    comparePropertyA = a[propertyNames[0]];
                    comparePropertyB = b[propertyNames[0]];
                    for (j = 1; j < propertyNamesCount; j++) {
                        comparePropertyA = comparePropertyA[propertyNames[j]];
                        comparePropertyB = comparePropertyB[propertyNames[j]];
                    }
                    if (comparePropertyA > comparePropertyB) {
                        return asc ? 1 : -1;
                    }
                    if (comparePropertyA < comparePropertyB) {
                        return asc ? -1 : 1;
                    }
                }
                return 0;
            });
        };
        /**
         * Converts first letters after a space to an upper case IE.
         * fort collins, croton-on-hudson, harper's ferry, coeur d'alene, o'fallon
         * becomes
         * Fort Collins, Croton-On-Hudson, Harper's Ferry, Coeur D'Alene, O'Fallon
         * @param input - The string to be converted
         * @returns { string }
         */
        Utilities.toTitleCase = function (input) {
            return input.replace(this.titleCaseRegex, function (x) { return x.toUpperCase(); });
        };
        /**
         * US Vehicle Identification Number (VIN) validation.
         * version 1.0 by Christopher Jordan
         * version 1.1 by RHPT, Peter Boughton &amp; Adam Cameron (original function rejected valid VINs)
         * see http://en.wikipedia.org/wiki/Vehicle_Identification_Number for VIN spec
         * http://stackoverflow.com/questions/26407015/javascript-jquery-vin-validator
         *
         * @param vin VIN to validate (Required)
         * @return Returns a boolean.
         * @author Christopher Jordan (cjordan@placs.net)
         * @version 1, February 19, 2013
         */
        Utilities.isValidVin = function (vin) {
            vin = (vin || '').toUpperCase();
            var char;
            var digit;
            var checkDigit;
            var sum = 0;
            var vinRegex = new RegExp('^[A-Z\\d]{17}$', 'i');
            if (!vinRegex.test(vin)) {
                return false;
            }
            for (var index = 0; index < vin.length; ++index) {
                char = vin.charAt(index);
                digit = Number(char);
                var w = Utilities.weights[index];
                if (isNaN(digit)) {
                    digit = Utilities.transliterations[char];
                }
                sum += digit * w;
            }
            checkDigit = sum % 11;
            if (checkDigit === 10) {
                checkDigit = 'x';
            }
            var actualDigit = vin.charAt(8);
            return checkDigit === actualDigit;
        };
        Utilities.titleCaseRegex = /(\b[a-z](?!\s))/g;
        Utilities.weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
        Utilities.transliterations = { A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9, S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9 };
        return Utilities;
    }());
    ap.Utilities = Utilities;
})(ap || (ap = {}));
